<template>
  <div class="bk-header flex gap--header text--left">
    <img
      :src="image || 'https://dv-massiv.com/wp-content/uploads/noavatar.png'"
      class="bk-header__image"
      width="100"
      height="100"
    />
    <div class="bk-header__info flex flex--col">
      <h3 class="text-16 fw-700">{{name}}</h3>
      <div class="flex flex--col gap-12">
        <div class="flex flex--col gap-12">
          <p class="text-14 fw-500 color-disabled">{{getRelatedMethod(slots[0]).name}} ({{getRelatedMethod(slots[0]).duration}} min)</p>
        </div>
        <div class="flex flex--col">
          <bk-slot
            v-for="(slot, index) in slots"
            :date="getDateAndMonth(slot.time)"
            :time="getTime(slot.time)"
            :price="price"
            :currency="currency"
            :key="index"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone';
  import BkSlot from "./Slot.vue";

  export default {
    components: { BkSlot },
    props: [
      'image',
      'name',
      'slots',
      'price',
      'currency',
      'getRelatedMethod',
      'getTime',
    ],
    name: 'bkHeader',
    methods: {
      getDateAndMonth(date) {
        return moment.utc(date).format('DD. MMMM YYYY');
      },
    }
  }
</script>

<style lang="less">
@import "../../less/redesign/base";
  .bk-header__image {
    border-radius: 20px;
    object-fit: cover;
    width: 100px;
    height: 100px;
    flex-shrink: 0;
  }
  .bk-header__info {
    min-width: 0;
    overflow: hidden;
  }
  .gap--header {
    gap: 16px;
  }
  .gap-12 {
    gap: 12px;
  }
  @media screen and (max-width: 480px) {
    .bk-header__image {
      width: 80px;
      height: 80px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/Header.vue